const $ = jQuery.noConflict();

export default function ajaxForm() {
    $(".form-ajax").on("submit", function onSubmit(event) {
        event.preventDefault();

        const $form = $(this);
        const $status = $form.find(".form-status");
        const action = $form.attr("action");
        const nonce = $form.find(`[name=${action}_nonce]`).val();

        $status.html('<div class="loader"></div>');

        $.post({
            dataType: "json",
            url: siteObject.ajaxurl,

            data: {
                action,
                data: $(this).serialize(),
                nonce,
            },

            success(response) {
                $status.html(
                    `<div class="form-message form-message--${response.status}">${response.message}</div>`
                );

                if (action === "login" && response.status === "success") {
                    document.location.href = siteObject.partners_url;
                }
            },
        });
    });
}
